import { Component, ViewChild, Output, EventEmitter } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { FacilityService } from '../../../services';
import { AppUtils } from '../../../helpers';

@Component({
    selector: 'app-facility-challenge-delete',
    templateUrl: './facility.challenge.delete.component.html'
})

export class FacilityChallengeDeleteComponent {
    @BlockUI('container-blockui-delete-popup') blockUI: NgBlockUI;
    @ViewChild('facilityDeleteConfirmationModal', { static: true }) facilityDeleteConfirmationModal: any;
    @Output() deleteFacility = new EventEmitter<any>();
    modalReference: NgbModalRef;
    deleteChallengeMessage: string;
    deleteConfirmationMessage: string;
    isModelLoaded = false;
    dualConfirmationRequired = true;

    constructor(private toastr: ToastrService,
        private modalService: NgbModal,
        private facilityService: FacilityService,
        private appUtils: AppUtils) { }

    challengeDelete(id: number, facilityName: string): void {
        this.blockUI.start();
        this.facilityService.getFacilityStatisticsOfActiveRecords(id)
            .subscribe(
                (data: any) => {
                    this.blockUI.stop();
                    this.deleteConfirmationMessage = this.getDeleteConfirmationMessage(data, facilityName);
                    this.isModelLoaded = true;
                },
                error => {
                    this.blockUI.stop();
                    this.appUtils.ProcessErrorResponse(this.toastr, error);
                });
    }

    getDeleteConfirmationMessage(data: any, facilityName: string) {
        let htmlMessage = '';
        if (data.totalUnits === 0
            && data.totalWorkOrders === 0) {
            this.deleteChallengeMessage = 'DELETE';
            this.dualConfirmationRequired = false;
            htmlMessage = 'Are you sure you want to delete the facility? This action is irreversible.';
        } else {
            let flag = false;
            htmlMessage = facilityName + ' has ';
            if (data.totalUnits > 0) {
                flag = true;
                htmlMessage += data.totalUnits + ' active ' + (data.totalUnits === 1 ? 'unit ' : ' units ');
            }
            if (data.totalWorkOrders > 0) {
                htmlMessage += (flag ? ', ' : '') +
                    (data.totalUnits > 0 ? 'and ' : '')
                    + data.totalWorkOrders + ' active ' + (data.totalWorkOrders === 1 ? 'work order ' : 'work orders ');
            }
            if (htmlMessage.endsWith(',') || htmlMessage.endsWith(', ')) {
                htmlMessage = htmlMessage.trim().substr(0, htmlMessage.length - 1);
            }

            htmlMessage += 'associated. Deleting ' + facilityName + ' will delete all the data associated with it. \n'
                + 'Are you sure you want to proceed?';
        }

        return htmlMessage;
    }

    openFacilityDeleteConfirmationModal(id: number, facilityName: string) {
        this.modalReference = this.modalService.open(this.facilityDeleteConfirmationModal);
        this.challengeDelete(id, facilityName);
    }

    delete() {
        this.closeFacilityDeleteConfirmationModal();
        setTimeout(() => {
            this.deleteFacility.emit();
        });
    }

    closeFacilityDeleteConfirmationModal() {
        this.modalReference.close();
        this.deleteChallengeMessage = null;
        this.deleteConfirmationMessage = null;
        this.isModelLoaded = false;
        this.dualConfirmationRequired = true;
    }

    deleteChallengeMessageChanged() {
        this.deleteChallengeMessage = this.deleteChallengeMessage.toUpperCase();
    }

}
